import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AVAILABLE_LANGUAGES } from 'src/app/core/constants/language.constants';

@Component({
  selector: 'verify-email-page',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    TranslateModule
],
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {
  public translate = inject(TranslateService);

  ngOnInit() {
    console.warn('[VerifyEmailComponent] Entered verify email page 📧');
    const supportedCodes = AVAILABLE_LANGUAGES.map(l => l.code);
    const browserLang = this.translate.getBrowserLang();
    const langToUse = supportedCodes.includes(browserLang) ? browserLang : 'en';

    this.translate.setDefaultLang('en');
    this.translate.use(langToUse);

  }

}
